import { alpha, Box, Stack, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";

export default function PaymentCardItem(props) {
    const { icon, title, des, endWidget } = props;
    const { mode } = useColorScheme();
    const currentMode = mode || "system";
    return (
        <Stack
            direction={{
                xs: "column",
                sm: "row",
            }}
            alignItems={{
                xs: "start",
                sm: "center",
            }}
            justifyContent={"space-between"}
            sx={{
                padding: {
                    xs: `calc(${Constants.Styles.spacing} * 2)`,
                    sm: `calc(${Constants.Styles.spacing} * 3)`,
                },
                backgroundColor: alpha(Constants.Colors[currentMode].secondary, 0.3),
                border: `1px solid ${Constants.Colors[currentMode].border}`,
                borderRadius: `calc(${Constants.Styles.radius.base} - 2px)`,
            }}
            spacing={1}
        >
            <Stack
                direction={"row"}
                alignItems={"center"}
                spacing={`calc(${Constants.Styles.spacing} * 4)`}
            >
                <Box
                    sx={{
                        width: `calc(${Constants.Styles.spacing} * 14)`,
                        height: `calc(${Constants.Styles.spacing} * 10)`,
                        borderRadius: "0.25rem",
                        backgroundColor: Constants.Colors[currentMode].card,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: `1px solid ${Constants.Colors[currentMode].border}`,
                    }}
                >
                    {icon}
                </Box>
                <Box>
                    <Typography
                        sx={{
                            fontWeight: Constants.Styles.fontWeight.medium,
                            fontSize: Constants.Styles.fontSize.sm,
                            lineHeight: Constants.Styles.lineHeight.sm,
                            color: Constants.Colors[currentMode].foreground,
                        }}
                    >{title}</Typography>
                    <Typography sx={{
                        fontWeight: Constants.Styles.fontWeight.regular,
                        fontSize: Constants.Styles.fontSize.xs,
                        lineHeight: Constants.Styles.lineHeight.xs,
                        color: Constants.Colors[currentMode].mutedForeground,
                    }}>{des}</Typography>
                </Box>
            </Stack>
            {
                endWidget && (
                    <Box>
                        {endWidget}
                    </Box>
                )
            }
        </Stack>
    );
}